import useGetApi from 'src/api/useGetApi';
import { ProductVariantDTO } from 'src/types/application/inventory-management/ProductVariantDTO';

interface AttributeDescription {
  name: string;
  value: string;
}

interface GetProductVariantResponse {
  productVariant: ProductVariantDTO;
  attributeDescriptions?: AttributeDescription[];
}

interface UseProductVariantOptions {
  enabled?: boolean;
  includeInactive?: boolean;
}

const useProductVariant = (
  productVariantId: string,
  { enabled = true, includeInactive = false }: UseProductVariantOptions = {},
) => {
  return useGetApi<GetProductVariantResponse>({
    endpoint: `inventory-management/products-v2/product-variants/${productVariantId}`,
    queryParameters: includeInactive ? { includeInactive: true } : undefined,
    options: {
      enabled: enabled && !!productVariantId,
    },
  });
};

export default useProductVariant;
